<template>
  <div
    class="account-detail"
    v-if="
      dataUser &&
      dataUser.permissionCodes?.includes('CNPS_AGENT_PARTNER_BANK_DETAIL')
    "
  >
    <div class="breadcrumb-area pos-relative w-100 mb-3">
      <h1>Chi tiết tài khoản</h1>
      <div class="float-right">
        <button
          v-if="
            dataUser &&
            dataUser.permissionCodes?.includes('CNPS_AGENT_PARTNER_BANK_UPDATE')
          "
          class="btn btn-outline-secondary mr-2"
          @click="navigateToUpdate"
        >
          <i class="bx bx-edit"></i> Cập nhật
        </button>
        <button
          v-if="
            detail.stateAgent === 'ACTIVE' &&
            dataUser.permissionCodes.includes(
              'CNPS_AGENT_PARTNER_BANK_LOCK_UNLOCK'
            )
          "
          class="btn btn-outline-secondary mr-2"
          @click="showLockModal"
        >
          <i class="bx bx-lock"></i> Khoá
        </button>
        <button
          v-else-if="
            detail.stateAgent === 'LOCKED' &&
            dataUser.permissionCodes.includes(
              'CNPS_AGENT_PARTNER_BANK_LOCK_UNLOCK'
            )
          "
          class="btn btn-outline-secondary mr-2"
          @click="showUnlockModal"
        >
          <i class="bx bx-lock-open"></i> Mở khoá
        </button>
        <button
          class="btn btn-outline-secondary"
          @click="$router.push('/agent-bank')"
        >
          <i class="bx bx-arrow-back"></i> Quay lại
        </button>
      </div>
    </div>

    <div class="mx-3" style="max-width: 600px">
      <Card
        style="box-shadow: none; border: 1px solid #d7d7d7"
        title="Thông tin tài khoản"
        v-if="detail"
      >
        <Content title="Tên tài khoản" :content="detail.name"></Content>
        <Content title="Đối tác" :content="detail.partnerCode"></Content>
        <Content title="Loại tài khoản" :content="detail.typeDigital ==='NORMAL'?'Tài khoản tự bán thiết b':'Tài khoản giới thiệu merchant'"></Content>
        <Content title="Email" :content="detail.email"></Content>
        <Content title="Số điện thoại" :content="detail.mobile"></Content>
        <Content title="Mã Agent" :content="detail.agentId"></Content>
        <Content
          title="Cấp độ"
          :content="getLevelLabel(detail.level)"
        ></Content>

        <Content title="Trạng thái">
          <span :class="getStatusClass(detail.stateAgent)">
            {{ getStatusLabel(detail.stateAgent) }}
          </span>
        </Content>
        <!-- <Content title="Khu vực" :content="detail.regionCode"></Content> -->
        <Content title="Tỉnh/Thành phố" :content="detail.cityName"></Content>
        <Content title="Quận/Huyện" :content="detail.districtName"></Content>
        <Content title="Địa chỉ chi tiết" :content="detail.address"></Content>
        <Content
          v-if="detail.managerId"
          title="Quản lý bởi"
          :content="detail.managerName || findManagerName(detail.managerId)"
        ></Content>
        <Content v-else title="Quản lý bởi" content="Không có"></Content>
        <Content title="Thời gian tạo">
          {{ formatDateTime(detail.createdDate) }}
        </Content>
        <Content v-if="detail.lastModifiedDate" title="Thời gian cập nhật">
          {{ formatDateTime(detail.lastModifiedDate) }}
        </Content>
      </Card>
    </div>
    <!-- Add modal with centered class -->
    <b-modal
      v-model="showActionModal"
      :title="modalTitle"
      hide-footer
      centered
      dialog-class="modal-dialog-centered"
    >
      <div class="mb-5">
        <p>{{ modalMessage }}</p>
      </div>
      <div class="d-flex justify-content-end">
        <b-button variant="light" class="mr-2" @click="showActionModal = false">
          Huỷ
        </b-button>
        <b-button variant="primary" @click="confirmAction"> Xác nhận </b-button>
      </div>
    </b-modal>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true">
    </VueLoadingOverlay>
  </div>
</template>

<script>
import Card from '@/components/common/Card.vue'
import Content from '@/components/common/Content.vue'
import { CommonService } from '@/services/common.service'

export default {
  name: 'AccountDetail',
  data () {
    return {
      dataUser: JSON.parse(localStorage.getItem('userData')),
      showLoading: false,
      detail: {},
      showActionModal: false,
      actionType: null, // 'lock' or 'unlock'
      modalTitle: '',
      modalMessage: '',
      levelOptions: [
        { value: '0', label: 'Cấp 0' },
        { value: '1', label: 'Cấp 1' },
        { value: '2', label: 'Cấp 2' }
      ],
      statusOptions: [
        { value: 'ACTIVE', label: 'Hoạt động', variant: 'success' },
        { value: 'INACTIVE', label: 'Không hoạt động', variant: 'danger' },
        { value: 'LOCKED', label: 'Khoá', variant: 'danger' }
      ]
    }
  },

  components: { Card, Content },

  async created () {
    await this.getAccountDetail()
  },

  methods: {
    navigateToUpdate () {
      this.$router.push(`/agent-bank/edit/${this.$route.params.id}`)
    },

    showLockModal () {
      this.actionType = 'lock'
      this.modalTitle = 'Khoá tài khoản'
      this.modalMessage = `Bạn có chắc chắn muốn khoá tài khoản "${this.detail.name}" không?`
      this.showActionModal = true
    },

    showUnlockModal () {
      this.actionType = 'unlock'
      this.modalTitle = 'Mở khoá tài khoản'
      this.modalMessage = `Bạn có chắc chắn muốn mở khoá tài khoản "${this.detail.name}" không?`
      this.showActionModal = true
    },

    async confirmAction () {
      this.showLoading = true
      try {
        let res
        if (this.actionType === 'lock') {
          res = await CommonService.lockUserBank({ id: this.detail.id })
        } else if (this.actionType === 'unlock') {
          res = await CommonService.lockUserBank({ id: this.detail.id })
        }

        if (res && res.success) {
          const message =
            this.actionType === 'lock'
              ? 'Khoá tài khoản thành công'
              : 'Mở khoá tài khoản thành công'
          this.showSuccessMx(message).then(() => {
            this.getAccountDetail() // Refresh data
          })
        } else {
          this.showFailMx(res.message || 'Thao tác thất bại')
        }
      } catch (error) {
        this.showFailMx(error.message ?? error)
      } finally {
        this.showLoading = false
        this.showActionModal = false
      }
    },
    async getAccountDetail () {
      this.showLoading = true
      try {
        const res = await CommonService.detailteUserBank(this.$route.params.id)
        if (res.success) {
          this.detail = res.data
        } else {
          this.showFailMx(res.message)
        }
      } catch (error) {
        this.showFailMx(error.message ?? error)
      } finally {
        this.showLoading = false
      }
    },

    getLevelLabel (level) {
      const found = this.levelOptions.find((option) => option.value === level)
      return found ? found.label : `Cấp ${level}`
    },

    getStatusLabel (status) {
      const found = this.statusOptions.find(
        (option) => option.value === status
      )
      return found ? found.label : status
    },

    getStatusClass (status) {
      const found = this.statusOptions.find(
        (option) => option.value === status
      )
      return found ? `text-${found.variant}` : ''
    },

    findManagerName (managerId) {
      // This would typically fetch from a list of managers
      // For now we'll return a placeholder
      return `Manager ID: ${managerId}`
    },

    formatDateTime (dateString) {
      if (!dateString) return 'N/A'
      const date = new Date(dateString)
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()

      return `${hours}:${minutes}, ${day}/${month}/${year}`
    }
  }
}
</script>

<style scoped>
.breadcrumb-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.text-success {
  color: #28a745 !important;
}

.text-danger {
  color: #dc3545 !important;
}
::v-deep .modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}

/* Optional: Add some minimal width to ensure modal isn't too narrow */
::v-deep .modal-dialog {
  min-width: 320px;
}
</style>
